module.exports = __webpack_public_path__ + "static/media/cq_scarica b.484063a0.svg";